// Phase 42: lazy-loaded chart wrappers for the Dashboard.
//
// recharts is a heavy dependency (~150 kB gzipped). Most users only see
// the chart after a few seconds of staring at the KPI cards, so we load
// the TrendChart and CategoryDonut via React.lazy and let Vite carve
// them out into a separate chunk. The KPI cards, recent transactions
// list, and credit-card reminders all stay in the synchronous bundle
// because they render with the first paint.
//
// Each chart is wrapped in its own <Suspense> so a slow chart fetch
// doesn't block the others, and so each can show a tiny skeleton
// fallback that matches its height (avoids layout shift on load).
import React, { Suspense, lazy } from 'react';

const TrendChart     = lazy(() => import('./TrendChart.jsx'));
const CategoryDonut  = lazy(() => import('./CategoryDonut.jsx'));
const AccountDonut   = lazy(() => import('./AccountDonut.jsx'));

// Lightweight skeleton that matches the chart's height so the page
// doesn't jump when the real chart lands. Uses Tailwind animate-pulse
// so it works in both light + dark mode without extra theme logic.
function Skeleton({ height = 220 }) {
  return (
    <div
      className="w-full rounded bg-slate-100 dark:bg-slate-700 animate-pulse"
      style={{ height }}
      aria-hidden="true"
    />
  );
}

export function DashboardTrendChart(props) {
  return (
    <Suspense fallback={<Skeleton height={220} />}>
      <TrendChart {...props} />
    </Suspense>
  );
}

export function DashboardCategoryDonut(props) {
  return (
    <Suspense fallback={<Skeleton height={220} />}>
      <CategoryDonut {...props} />
    </Suspense>
  );
}

export function DashboardAccountDonut(props) {
  return (
    <Suspense fallback={<Skeleton height={220} />}>
      <AccountDonut {...props} />
    </Suspense>
  );
}